import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NAV = [
  ['/', 'Dashboard'], ['/companies', 'Companies'], ['/subscriptions', 'Subscriptions'], ['/users', 'Users'],
];

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex">
      <aside className="w-60 bg-primary-600 text-white flex flex-col">
        <div className="px-5 py-4 text-lg font-bold">Kloa Absen — Platform Admin</div>
        <nav className="flex-1 px-2 space-y-1">
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === '/'}
              className={({ isActive }) => `block px-3 py-2 rounded text-sm ${isActive ? 'bg-white/20 font-semibold' : 'hover:bg-white/10'}`}>
              {label}
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} className="m-3 px-3 py-2 text-sm rounded bg-white/10 hover:bg-white/20">Logout</button>
      </aside>
      <div className="flex-1 flex flex-col bg-gray-50">
        <header className="h-14 bg-white border-b flex items-center justify-end px-6 text-sm text-gray-600">{user?.full_name}</header>
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
};
export default Layout;
